module.exports = __webpack_public_path__ + "img/LANGEBIO.1ce8ba31.jpg";